import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Car, LogOut, LayoutDashboard, MessageSquare, FileText, Brain } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  return (
    <header className="sticky top-0 z-50 w-full bg-background border-b border-border" data-testid="main-header">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="logo-link">
          <Car className="w-7 h-7 text-primary" />
          <span className="text-xl font-heading font-bold tracking-tight">Volt Usta</span>
        </Link>

        <nav className="flex items-center gap-2">
          <Link to="/" data-testid="nav-chat-link">
            <Button variant="ghost" className="rounded-sm hover:bg-secondary text-sm">
              <MessageSquare className="w-4 h-4 mr-2" />
              Sohbet
            </Button>
          </Link>

          <Link to="/incelemeler" data-testid="nav-reviews-link">
            <Button variant="ghost" className="rounded-sm hover:bg-secondary text-sm">
              <FileText className="w-4 h-4 mr-2" />
              İncelemeler
            </Button>
          </Link>

          {user && user.role === 'admin' && (
            <Link to="/admin" data-testid="nav-admin-link">
              <Button variant="ghost" className="rounded-sm hover:bg-secondary text-sm">
                <LayoutDashboard className="w-4 h-4 mr-2" />
                Yönetim
              </Button>
            </Link>
          )}

          {user && (
            <Link to="/hafizam" data-testid="nav-memory-link">
              <Button variant="ghost" className="rounded-sm hover:bg-secondary text-sm">
                <Brain className="w-4 h-4 mr-2" />
                Hafızam
              </Button>
            </Link>
          )}

          {user ? (
            <Button
              onClick={handleLogout}
              variant="ghost"
              className="rounded-sm hover:bg-secondary text-sm"
              data-testid="logout-button"
            >
              <LogOut className="w-4 h-4 mr-2" />
              Çıkış
            </Button>
          ) : (
            <Link to="/login" data-testid="nav-login-link">
              <Button className="rounded-sm bg-primary text-primary-foreground hover:bg-primary/90 text-sm">
                Giriş Yap
              </Button>
            </Link>
          )}
        </nav>
      </div>
    </header>
  );
};

export default Header;
